import { render, staticRenderFns } from "./ReportItemProducts.vue?vue&type=template&id=fc62cf96&"
import script from "./ReportItemProducts.vue?vue&type=script&lang=js&"
export * from "./ReportItemProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReportItemProducts.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports